<template>
  <div class="home">
    <Nav />
    <div class="banner-img">
      <img src="../assets/05.png" />
    </div>
    <div class="main">
      <div class="pro-info">
        <div>
          <h3>Q. 金蝶效贷贷款需要准备什么资料？</h3>
          <div class="mt25">A. 身份证、KIS数据授权、税采授权等。</div>
        </div>
        <div>
          <h3>Q. 产品借款年龄限制是什么？</h3>
          <div class="mt25">A. 22~55岁。</div>
        </div>
        <div>
          <h3>Q. 金蝶效贷办理贷款流程步骤是什么？</h3>
          <div class="mt25">A. 阳光效贷：登录金蝶效贷官网--选择阳光效贷--录入企业基本信息--KIS数据授权--税采数据授权

            --简版人行征信授权--贷款审批--审核通过，缴纳手续费--放款</div>
        </div>
        <div>
          <h3>Q. 员员贷可以在哪里申请？</h3>
          <div class="mt25">A. 该贷款仅针对金蝶集团员工，不对外部企业开放。金蝶员工可在云之家申请贷款。
          </div>
        </div>
        <div>
          <h3>Q. 贷款利率水平及年化综合费率和费用项目标准是怎样的？
          </h3>
          <div class="mt25">A. 见产品详情介绍</div>
        </div>
        <div>
          <h3>Q. 业务投诉电话是多少</h3>
          <div class="mt25">A.  0755-86072588</div>
        </div>
        <div>
          <h3>Q. 逾期处理方式及逾期费用怎么计算？</h3>
          <div class="mt25">A. 见产品详情介绍</div>
        </div>
        <div>
          <h3>Q. 逾期会有什么影响？</h3>
          <div class="mt25">A. 如果逾期，会将您的不良还款行为上传到相关单位，并向您收取罚息。</div>
        </div>
        <div>
          <h3>Q. 是否接入人行征信系统？</h3>
          <div class="mt25">A. 正在接入人行征信</div>
        </div>
        <div>
          <h3>Q. 是否接入百行征信系统？</h3>
          <div class="mt25">A. 已接入百行征信</div>
        </div>
        <div>
          <h3>Q. 监督举报电话是多少？</h3>
          <div class="mt25">A. 020-12345</div>
        </div>
      </div>
      <Foot class="mt100"/>
    </div>
  </div>
</template>

<script>
import Nav from './Nav';
import Foot from './Foot';

export default {
  name: 'Home',
  components: { Nav, Foot },
  props: {
  },
  mounted() {
    this.$nextTick(() => {
      document.getElementsByClassName('help-tab')[0].style.color = '#F29700';
    });
  },
  methods: {
    effectiveLoanEvent() {
      this.$router.push({ path: `/permission/index?${+new Date()}` });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .home{
    .banner-img{
      img{
        width: 100%;
      }
    }
    .main{
      height:729px;
      padding-bottom: 100px;
      .pro-info{
        position: relative;
        margin-left: 25%;
        .black-bl{
          position: absolute;
          top: -17px;
          color: rgba(51,47,43,1);
          font-weight: 500;
          font-size: 26px;
        }
        div{
          font-size:13px;
          font-family:PingFangSC-Regular;
          font-weight:400;
          color:rgba(142,142,142,1);
          line-height:26px;
        }
        .mt25{
          margin-top: 25px;
        }
        h3{
          padding-top: 70px;
          font-size:20px;
          color:rgba(51,47,43,1);
        }
        .mt40{
          margin-top: 40px;
        }
        .ml60{
          margin-left: 3.125%;
        }
      }
    }

  }

</style>
